import React, { useState } from "react";

import Fooduserorders from "./Fooduserorders";
import Fooduserwalletorders from './Fooduserwalletorders';


const TabsLayout = () => {
  const [activeTab, setActiveTab] = useState("orders");

  const DummySection = ({ title }) => (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );

  const renderComponent = () => {
    switch (activeTab) {
      case "orders":
        return <Fooduserorders />;
      // case "Wallet Orders":
      //   return <Fooduserwalletorders />;
      //   case "Summery":
      //     return <Foodsubscribedclients title="Summery" />;

      default:
        return <Fooduserorders />;
    }
  };

  const tabs = [
    "orders",
    // "Wallet Orders",


  ];

  return (
    <div className="tabs-wrapper" style={{ width: "77vw" }}>
      {/* TOP ONE-ROW TABS (ALL SCREENS) */}
      <div className="tabs-row">
        {tabs.map((tab) => (
          <span
            key={tab}
            className={`row-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </span>
        ))}
      </div>

      {/* CONTENT */}
      <div className="tabs-content">
        {renderComponent()}
      </div>
    </div>
  );
};

export default TabsLayout;

